import styled from '@emotion/styled/macro'

const ErrorMessage = styled('div')`
  background-color: var(--danger-2);
  color: white;
  margin-bottom: 1rem;
  padding: 1rem;
  text-align: center;
  width: 100%;

  span[role='button'] {
    color: white;
    cursor: pointer;
    text-decoration: underline;
  }
`

export default ErrorMessage
